import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from 'app/service/error.service';

@Component({
  selector: 'app-error403',
  templateUrl: './error403.component.html',
  styleUrls: ['./error403.component.css']
})
export class Error403Component implements OnInit {

  constructor(
    public ers: ErrorService,
    public router: Router,
  ) { }

  ngOnInit() {
  }

  previousMain() {
    const dataSend = {
      type: 'noerror',
    };
    this.ers.injectonSubject(dataSend);
    this.router.navigate(['main']);
  }

}
